import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/customers/:customerId/send-message`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const sendMessage = {
  post: apiPathFunc(pathBase),
};
